import React from "react";
import { DeviceItem } from "Components/overview/index";
import { useDeviceConfigEntries, useSystemId } from "../../../hooks/useReduxSelectors";

const Devices = ({ isCompact }) => {
  const systemId = useSystemId();
  const devices = useDeviceConfigEntries();

  return (
    devices &&
    devices.length > 0 &&
    devices.map((device) => (
      device.hwId !== "EdgeDevice" &&
      <DeviceItem
        hwId={device.hwId}
        key={systemId + "_" + device.hwId}
        isCompact={isCompact}
      />
    ))
  );
};

export default Devices;
